<script>
    import { createAssetType } from '@/api/assetType.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_ASSET_TYPE_ADD}
        },
        methods: {
            async create() {
                const data = this.$store.getters.ASSET_TYPE_DATA_ADD;
                const response = await createAssetType(data);
                if (response != null) {
                    this.$store.commit('ASSET_TYPE_PUSH', response);
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_ASSET_TYPE_ADD', false);
            }
        }
    }
</script>


<template>
    <button
        :disabled="isSave === false"
        @click="create"
        class="button_blue_100"
    >Create</button>
    <button
        @click="close"
        class="button_blue_100 close_button mr_10"
    >Close</button>
</template>